enum SalesDataConstants {
  POST_SALES_FILE_REQUEST = "POST_SALES_FILE_REQUEST",
  POST_SALES_FILE_SUCCESS = "POST_SALES_FILE_SUCCESS",
  POST_SALES_FILE_FAILURE = "POST_SALES_FILE_FAILURE",

  GET_FILE_COLUMNS_REQUEST = "GET_FILE_COLUMNS_REQUEST",
  GET_FILE_COLUMNS_SUCCESS = "GET_FILE_COLUMNS_SUCCESS",
  GET_FILE_COLUMNS_FAILURE = "GET_FILE_COLUMNS_FAILURE",

  GET_SALES_FILES_REQUEST = "GET_SALES_FILES_REQUEST",
  GET_SALES_FILES_SUCCESS = "GET_SALES_FILES_SUCCESS",
  GET_SALES_FILES_FAILURE = "GET_SALES_FILES_FAILURE",

  MAP_TO_RAW_DATA_REQUEST = "MAP_TO_RAW_DATA_REQUEST",
  MAP_TO_RAW_DATA_SUCCESS = "MAP_TO_RAW_DATA_SUCCESS",
  MAP_TO_RAW_DATA_FAILURE = "MAP_TO_RAW_DATA_FAILURE",

  COLUMN_MAP_REQUEST = "COLUMN_MAP_REQUEST",
  SET_FILTERED_FILE_COLS_REQUEST = "SET_FILTERED_FILE_COLS_REQUEST",

  GET_MASTER_DATA_REQUEST = "GET_MASTER_DATA_REQUEST",
  GET_MASTER_DATA_SUCCESS = "GET_MASTER_DATA_SUCCESS",
  GET_MASTER_DATA_FAILURE = "GET_MASTER_DATA_FAILURE",

  EDIT_MASTER_DATA_REQUEST = "EDIT_MASTER_DATA_REQUEST",
  EDIT_MASTER_DATA_SUCCESS = "EDIT_MASTER_DATA_SUCCESS",
  EDIT_MASTER_DATA_FAILURE = "EDIT_MASTER_DATA_FAILURE",

  DELETE_MASTER_DATA_REQUEST = "DELETE_MASTER_DATA_REQUEST",
  DELETE_MASTER_DATA_SUCCESS = "DELETE_MASTER_DATA_SUCCESS",
  DELETE_MASTER_DATA_FAILURE = "DELETE_MASTER_DATA_FAILURE",

  PROCESS_MASTER_DATA_REQUEST = "PROCESS_MASTER_DATA_REQUEST",
  PROCESS_MASTER_DATA_SUCCESS = "PROCESS_MASTER_DATA_SUCCESS",
  PROCESS_MASTER_DATA_FAILURE = "PROCESS_MASTER_DATA_FAILURE",

  DELETE_SALES_FILE_REQUEST = "DELETE_SALES_FILE_REQUEST",
  DELETE_SALES_FILE_SUCCESS = "DELETE_SALES_FILE_SUCCESS",
  DELETE_SALES_FILE_FAILURE = "DELETE_SALES_FILE_FAILURE",

  DELETE_PROCESSED_FILE_REQUEST = "DELETE_PROCESSED_FILE_REQUEST",
  DELETE_PROCESSED_FILE_SUCCESS = "DELETE_PROCESSED_FILE_SUCCESS",
  DELETE_PROCESSED_FILE_FAILURE = "DELETE_PROCESSED_FILE_FAILURE",

  DOWNLOAD_SALES_FILE_REQUEST = "DOWNLOAD_SALES_FILE_REQUEST",
  DOWNLOAD_SALES_FILE_SUCCESS = "DOWNLOAD_SALES_FILE_SUCCESS",
  DOWNLOAD_SALES_FILE_FAILURE = "DOWNLOAD_SALES_FILE_FAILURE",

  RESET_DOWNLOAD_SALES_FILE = "RESET_DOWNLOAD_SALES_FILE",
  RESET_SALES_FILES = "RESET_SALES_FILES",
}

export default SalesDataConstants;
